import { createNavigation } from "next-intl/navigation"

import { routing } from "./routing"

/**
 * Locale-aware navigation APIs (US-014). `createNavigation(routing)` returns
 * drop-in replacements for `next/link` / `next/navigation` that keep the active
 * `[locale]` prefix in sync (localePrefix is "always"):
 *
 *   - `Link`        — locale-prefixed <a>.
 *   - `useRouter`   — `router.replace(pathname, { locale })` swaps the active
 *                     locale segment (used by the language switcher).
 *   - `usePathname` — the current pathname WITHOUT the locale prefix, so the
 *                     switcher can re-target the same page under a new locale.
 *   - `redirect` / `getPathname` — server-side locale-aware redirect/build.
 *
 * `usePathname`/`useRouter` are client hooks; `redirect`/`getPathname` are usable
 * from Server Components.
 */
export const { Link, redirect, usePathname, useRouter, getPathname } =
  createNavigation(routing)
